import React from "react";
import { Link } from "react-router-dom";
import POSEditExcel from "../../../components/ClientDashboard/PosSync/POSEditExcel";

const FetchUpdatePOS = () => {
    return (
        <>
            {/* Breadcrumb */}
            <div className="breadcrumb-card">
                <h5>Edit POS Configuration</h5>

                <ul className="breadcrumb">
                    <li><Link to="/">
                        <i className="material-symbols-outlined">home</i>
                        Home
                    </Link>
                    </li>
                    <li><Link to="/pos-sync">
                        <i className="material-symbols-outlined"></i>
                        POS Management
                    </Link>
                    </li>
                    <li>Edit Mappings</li>
                </ul>
            </div>

            {/* Content goes here */}
            <div className="posSync-content">
                <POSEditExcel/>
            </div>
        </>
    );
}

export default FetchUpdatePOS;